import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.o5v_1 = delegate;
        this.p5v_1 = call;
      }
      *z59(frame, $completion) {
        yield* this.o5v_1.z59(frame, $completion);
        return Unit_instance;
      }
      *i4j($completion) {
        yield* this.o5v_1.i4j($completion);
        return Unit_instance;
      }
      v59(_set____db54di) {
        this.o5v_1.v59(_set____db54di);
      }
      w59() {
        return this.o5v_1.w59();
      }
      x59() {
        return this.o5v_1.x59();
      }
      y59() {
        return this.o5v_1.y59();
      }
      xv() {
        return this.o5v_1.xv();
      }
      u59(negotiatedExtensions) {
        this.o5v_1.u59(negotiatedExtensions);
      }
      t59() {
        return this.o5v_1.t59();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.q5v_1 = session;
        this.r5v_1 = call;
      }
      *z59(frame, $completion) {
        yield* this.q5v_1.z59(frame, $completion);
        return Unit_instance;
      }
      *i4j($completion) {
        yield* this.q5v_1.i4j($completion);
        return Unit_instance;
      }
      v59(_set____db54di) {
        this.q5v_1.v59(_set____db54di);
      }
      w59() {
        return this.q5v_1.w59();
      }
      x59() {
        return this.q5v_1.x59();
      }
      y59() {
        return this.q5v_1.y59();
      }
      xv() {
        return this.q5v_1.xv();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
